<template>
  <div v-if="records.length">
    <p class="font-2xl font-semibold leading-5 px-3 mb-2" v-text="heading"></p>
    <div class="-my-2 py-2 overflow-x-auto md:-mx-6 md:px-6 lg:-mx-8 lg:px-8">
      <div
        class="align-middle inline-block min-w-full overflow-hidden shadow rounded-md border border-gray-200 bg-white"
      >
        <div class="relative pl-6">
          <div
            class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
          >
            <svg
              class="h-4 w-4 text-gray-400"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                d="M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"
              />
            </svg>
          </div>
          <input
            type="text"
            placeholder="Filter by name"
            class="input rounded-t-md border-none focus:shadow-none focus:border-none"
            v-model="search"
          />
        </div>
        <table class="min-w-full border-t border-gray-200">
          <thead>
            <tr>
              <th
                class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
              >
                Document
              </th>
              <th
                class="w-4 text-right px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
              >
                Size
              </th>
              <th
                class="w-4 text-right px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
              >
                Modified
              </th>
              <th
                class="w-4 text-right px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
              >
                Description
              </th>
            </tr>
          </thead>
          <template v-if="filteredRecords.length > 0">
            <tbody v-for="record in filteredRecords" :key="record.value">
              <tr class="bg-white">
                <td
                  class="relative pl-12 pr-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900"
                >
                  <span
                    class="file-icon absolute left-0 top-0 inline-block w-5 h-5 mt-4 ml-6 bg-contain bg-no-repeat bg-center"
                    :class="record.extension"
                  ></span>
                  <div>
                    <a
                      v-if="record.has_file"
                      :href="record.url"
                      v-text="record.name"
                    ></a>
                    <span v-else v-text="record.name"></span>
                  </div>
                </td>
                <td
                  class="text-right px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500"
                >
                  <span v-if="record.has_file" v-text="record.size"></span>
                  <span v-else>---</span>
                </td>
                <td
                  class="text-right px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500"
                >
                  <span v-if="record.date" v-text="record.date"></span>
                  <span v-else>---</span>
                </td>
                <td
                  class="text-right px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900"
                >
                  <span
                    class="cursor-pointer text-blue hover:text-secondary"
                    v-if="record.excerpt"
                    @click="expand(record.value)"
                  >
                    Description
                  </span>
                  <span v-else>---</span>
                </td>
              </tr>
              <tr
                v-if="expanded === record.value"
                class="border-t border-dashed border-gray-200"
              >
                <td
                  colspan="4"
                  class="px-6 py-4 text-sm leading-5 bg-gray-100"
                  v-html="record.excerpt"
                ></td>
              </tr>
            </tbody>
          </template>
          <template v-else>
            <tbody class="bg-secondary">
              <tr>
                <td
                  colspan="4"
                  class="text-left px-6 py-4 whitespace-no-wrap text-sm leading-5 text-white"
                >
                  There are no records matching "{{ search }}"
                </td>
              </tr>
            </tbody>
          </template>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { AjaxCaller } from '@ssdcode/cms-partials';

export default {
  name: 'CategoryList',
  mixins: [AjaxCaller],
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      search: null,
      heading: '',
      records: [],
      expanded: null,
    };
  },
  computed: {
    url() {
      return '/data/category/' + this.id;
    },
    filteredRecords() {
      let records = this.records,
        keyword = this.search ? this.search.toLowerCase() : null;

      if (keyword) {
        return records.filter(record => {
          return record.name.toLowerCase().includes(keyword);
        });
      }

      return records;
    },
  },
  created() {
    this.initialise();
  },
  methods: {
    initialise() {
      this.makeAjaxRequest(this.success, this.failure, {}, this.url);
    },
    success(response) {
      this.heading = response.data.heading || '';
      this.records = response.data.records || [];
    },
    failure(error) {
      throw new Error(error);
    },
    expand(id) {
      this.expanded = this.expanded === id ? null : id;
    },
    artifacts(record) {
      let cont = [];
      if (record.has_file) {
        cont.push('<strong>Size:</strong> ' + record.size);
      }
      if (record.date) {
        cont.push('<strong>Modified:</strong> ' + record.date);
      }
      return cont.join(', ');
    },
  },
};
</script>
